import './MobileNews.scss'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import cardOne from '../../../../assets/img/cardImg1.jpeg'
import cardTwo from '../../../../assets/img/cardImg2.jpeg'
import cardThree from '../../../../assets/img/cardImg3.jpg'
import cardFour from '../../../../assets/img/cardImg4.svg'
import cardOne2 from '../../../../assets/img/banner12.png'
import cardTwo2 from '../../../../assets/img/banner22.png'
import cardThree2 from '../../../../assets/img/banner32.png'
import cardFour2 from '../../../../assets/img/banner42.png'
import MobileNewsCard from '../../MobileNewsCard/MobileNewsCard';
import MobileNewsPopup from '../../MobileNewsPopup/MobileNewsPopup';
import { useState } from 'react';

const news = [
  {
    id: 1,
    title: 'Компания «Технологии Арес» оказала поддержку Правительству Санкт-Петербурга в проведении Стратегической сессии.',
    description: 'Темы для обсуждения: 1. «ГосТех» для разработчиков и регионов. 2. Региональный пилот: проектный офис в Петербурге – первые итоги и дальнейший план работы. 3. Создание сети центров компетенций по ЕЦП «ГосТех». 4. Популяризация ЕЦП «ГосТех» - хакатоны, информационное продвижение. 5. Краудсорсинговая платформа ЕЦП «ГосТех». 6. Доступ разработчиков к среде ЕЦП «ГосТех». 7. Мультитенантность. 8. Информационная безопасность систем на ЕЦП «ГосТех». 9. Экспериментальный правовой режим для участников ЕЦП «ГосТех». 10. «ГосТех» для целей и задач укрепления обороноспособности Российской Федерации.',
    date: '23.06.2022',
    img: cardOne,
    img2: cardOne2,
    likes: 0,
    comments: 0
  },

  {
    id: 2,
    title: 'Цифровая платформа «Ares ERP» успешно внедрена в компанию «ЦСК»',
    description: 'Цифровая платформа «Ares ERP» успешно внедрена в компанию «ЦСК» и обеспечивает эффективную работу головной компании, а также территориально распределённых филиалов и всей логистики, что позволило увеличить выручку компании по итогам 1 полугодия 2022 года на 20%',
    date: '22.10.2022',
    img: cardFour,
    img2: cardThree2,
    likes: 0,
    comments: 0
  },
  {
    id: 3,
    title: 'Подписано соглашение с СибГУТИ об участии в проекте «Киберполигон»',
    description: 'Подписано соглашение с СибГУТИ об участии в проекте «Киберполигон» Предметом соглашения является развитие сотрудничества в области образования и науки, направленного на удовлетворение потребностей в подготовке кадров и повышении квалификации сотрудников. Главной задачей является установить долгосрочное и взаимовыгодное сотрудничество по следующим основным направлениям: Организация практик и стажировок, обучающихся по программам бакалавриата, магистратуры, аспирантуры Университета в Организации и трудоустройство выпускников. Разработка и реализация специальных образовательных программ с привлечением методических специалистов Университета и профессиональных экспертов. Организация профессиональных мастер-классов, соревнований, олимпиад, конкурсных отборов научно-исследовательских и инновационных проектов по приоритетным направлениям научно- технологического развития Российской Федерации. Создание специализированной исследовательской лаборатории с целью развития новых прогрессивных форм инновационной деятельности и научно-исследовательского сотрудничества.',
    date: '31.10.2022',
    img: cardTwo,
    img2: cardTwo2,
    likes: 0,
    comments: 0
  },
  {
    id: 4,
    title: 'Интеграция Метавселенной «Ares Meta» с платформами «Крибрум» и «Дневник.ру» ',
    description: 'Успешно завершены работы по интеграции с платформами «Крибрум» и «Дневник.ру». Интеграция позволит получать доступ к платформам через виртуальную среду.  ',
    date: '03.11.2022',
    img: cardThree,
    img2: cardFour2,
    likes: 0,
    comments: 0
  },

]

export default function MobileNews({newsRef}){


  const [visibility, setVisibility] = useState(false);

  const [clicked, setClicked] = useState('')

  const popupCloseHandler = (e) => {
    setVisibility(e);
  };

  const openPopup = (e) => {
    setVisibility(!visibility)
  }


  
  return(
    <div className='mobile-news' ref={newsRef}>
      <div className='mobile-news-title'>
        Новости
      </div>
      <Swiper
       modules={[Pagination, Navigation]}
       pagination
       navigation
       slidesPerView={1}
       scrollbar={{ draggable: true }}
       onSlideChange={() => console.log('slide change')}
       onSwiper={(swiper) => console.log(swiper)}
       centeredSlides="true"
      
        
      //   breakpoints = {{
      //     1024: {
      //         slidesPerView: 3,
      //         spaceBetween: 40
      //     },
      //     768: {
      //         slidesPerView: 3,
      //         spaceBetween: 30
      //     },
      //     640: {
      //         slidesPerView: 2,
      //         spaceBetween: 20
      //     },
      //     320: {
      //         slidesPerView: 1,
      //         spaceBetween: 10
      //     }
      // }}
      >
        {news.map((newsEl, index) => {
          return (
            <SwiperSlide style={{display: 'flex', justifyContent: 'center'}} key={newsEl.id}><MobileNewsCard newsNum={index} setClicked={setClicked} openPopup={openPopup} newsEl={newsEl} /></SwiperSlide>
          )
        })}
      </Swiper>
      
      <MobileNewsPopup onClose={popupCloseHandler}
            show={visibility} clicked={clicked} news={news} />
    


    </div>
  )
}

